import JsFunction from './JsFunction';
import ReturnMultipleType from './DataTypes/ReturnMultipleType';

export default class GetAllFunction extends JsFunction {
  nextFunction;

  apiCallPromisified = '';

  entityName = '';

  importModelParameter = [];

  modelNames = [];

  returnType;

  constructor(method, annotations, htmlDom) {
    super(method, annotations);
    this.inputHtmlElement = method.inputHtmlElement || '';
    this.apiCallPromisified = method.apiCallPromisified || '';
    this.entityName = method.entityName || '';
    this.importModelParameter = method.importModelParameter || [];
    this.modelNames = method.modelNames || [];
    this.returnType = new ReturnMultipleType(
      htmlDom,
      this.getMapOfEntitiesToAttributes().get(method.entityName),
      this.annotations,
      method.compId
    );
  }

  printImportStatement() {
    return this.apiInstance + this.importStatement + this.importModelParameter;
  }

  printFunction() {
    this.functionality += this.apiCallPromisified;

    this.functionality = this.functionality.replace(
      this.functionNextTemplate,
      this.returnType.printFunctionality()
    );
    this.printNextFunctionCode();

    this.functionality = this.returnType.clearTemplate(this.functionality);
    super.clearfunctionNextTemplate();
    return this.functionality;
  }

   printNextFunctionCode() {
    if (this.nextFunction)
      this.functionality = this.functionality.replace(
        this.functionNextTemplate,
        this.nextFunction.printFunction() + this.functionNextTemplate
      );
  }

  printEventToChangePage() {
    this.functionality = this.functionality.replace(
      this.returnType.insideForLoopTemplate,
      `${
        this.returnType.elementTemplate.elementArrayName
      }[i].addEventListener('click',() => {${this.nextFunction.printFunction({
        typeId: 'data[data.length -i -1]._id'
      })}} )`
    );
  }
}
